import { render, staticRenderFns } from "./pre-footer.vue?vue&type=template&id=5350da2a&scoped=true&"
import script from "./pre-footer.vue?vue&type=script&lang=js&"
export * from "./pre-footer.vue?vue&type=script&lang=js&"
import style0 from "./pre-footer.vue?vue&type=style&index=0&id=5350da2a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5350da2a",
  null
  
)

export default component.exports